import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { TextField, FormControl, FormHelperText } from '@material-ui/core';
import { validate as commonValidate } from './common';

var styles = function styles(theme) {
  return {
    cssLabel: {
      '&$cssFocused': {
        color: theme.palette.primary.main
      }
    },
    error: {
      '&$cssFocused': {
        color: '#FF2825'
      }
    },
    cssFocused: {},
    cssUnderline: {
      '&:after': {
        borderBottomColor: theme.palette.primary.main
      }
    }
  };
};

var InputText =
/*#__PURE__*/
function (_Component) {
  _inherits(InputText, _Component);

  function InputText() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, InputText);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(InputText)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.state = {
      isValid: true,
      errorMessage: undefined,
      text: ''
    }, _this.validate = function () {
      return commonValidate(_assertThisInitialized(_this), _this.state.text);
    }, _this.handleChange = function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          lazyValidation = _this$props.lazyValidation;

      _this.setState({
        text: event.target.value
      }, lazyValidation === undefined || lazyValidation === false ? _this.validate : function () {});

      if (onChange) {
        onChange(event.target.value);
      }
    }, _temp));
  } // Define this property to allow Form class validate this element


  _createClass(InputText, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var value = this.props.value;
      this.setState({
        text: value
      });
    }
    /**
     * This function is required for validating the component inside
     * a form.
     */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          onChange = _props.onChange,
          forwardedRef = _props.forwardedRef,
          customValidator = _props.customValidator,
          classes = _props.classes,
          hint = _props.hint,
          lazyValidation = _props.lazyValidation,
          errorMessages = _props.errorMessages,
          other = _objectWithoutProperties(_props, ['onChange', 'forwardedRef', 'customValidator', 'classes', 'hint', 'lazyValidation', 'errorMessages']);

      var _this$state = this.state,
          errorMessage = _this$state.errorMessage,
          isValid = _this$state.isValid;
      return React.createElement(FormControl, _extends({
        error: !isValid
      }, other), React.createElement(TextField, _extends({
        ref: function ref(_ref) {
          return _this2._text = _ref;
        },
        error: !isValid,
        InputLabelProps: {
          classes: {
            root: classes.cssLabel,
            focused: classes.cssFocused,
            error: classes.error
          }
        },
        InputProps: {
          classes: {
            underline: classes.cssUnderline
          }
        }
      }, other, {
        onChange: this.handleChange
      })), !isValid && React.createElement(FormHelperText, null, errorMessages ? errorMessages : errorMessage), isValid && React.createElement(FormHelperText, null, hint));
    }
  }]);

  return InputText;
}(Component);

InputText.propTypes = _extends({
  lazyValidation: PropTypes.bool,
  customValidator: PropTypes.func,
  errorMessages: PropTypes.array
}, TextField.propTypes);
export default withStyles(styles)(InputText);